<div class="checkin__landing__layout__image">
  <app-landing-bg></app-landing-bg>
</div>
<div class="checkin__landing__layout__right">
  <div class="checkin__landing__layout__header">
    <app-header [showLang]='true'></app-header>
  </div>
  <app-booking-localizer></app-booking-localizer>
</div>
